import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { PipeModule } from 'src/pages/pages/pipe.module';
import { CAT2025JSONIDService } from 'src/providers/cat-2025.service';

@Component({
  selector: 'app-course-card-home',
  templateUrl: './course-card-home.component.html',
  styleUrls: ['./course-card-home.component.scss'],
  standalone: true,
  imports: [CommonModule, MatTooltipModule, PipeModule, NgOptimizedImage]
})
export class CourseCardHomeComponent {


  @Input('course') course: any;

  @Input('pageName') pageName: any;

  constructor(public coursesService: CAT2025JSONIDService, public router: Router, @Inject(LOCAL_STORAGE) public sessionStorage: any,) {

  }

  ngOnInit(): void {

  }

  joinwhatsappEnquiry(link:any){
    let whatsappTemplate:any = `Hi iQuanta! 
    
    I’m interested in the ${this.course.course_name} and have a few questions about the syllabus, fees, batch dates and remaining seats. Could you please help me with the details? 
    
    Thanks!`
    window.open(link+'&text='+encodeURI(whatsappTemplate), '_blank')
    
    }

  getChipsData(rawHtml:any){
    const tempElement = document.createElement('div');
    tempElement.innerHTML = rawHtml;
  
    // Step 2: Extract text content
    const textContent = tempElement.innerText || tempElement.textContent || '';
  let splittedItems:any[]=textContent.split(',').map(item => item.trim()) ;
    // Step 3: Split by comma
    return splittedItems[0] != '.' ?  splittedItems : [];
  }

  enrollNow(course:any){
    if (this.course.display_only_one) {
    this.sessionStorage.setItem('enrollNow', 'true')
      window.open(this.course.course_link, '_self')
    } else {
      let courseId = course.id;
      this.coursesService.courseDetails(courseId).subscribe(res => {
        if (res.length > 0) {
          this.courseDetails = res[0];
          this.sessionStorage.setItem('cartArray', JSON.stringify(this.courseDetails))
          this.router.navigate(['cart'])
        }
      })
    }
  }

  getEmiAmount(principal:any) {
    let annualRate = 16; // 16% annual interest
    let tenureMonths = 6;
    let monthlyRate = annualRate / (12 * 100);
    let emi = (principal * monthlyRate * Math.pow(1 + monthlyRate, tenureMonths)) / (Math.pow(1 + monthlyRate, tenureMonths) - 1);
    return emi.toFixed(2);
  }

  goToCoureLink(course: any) {
    if (course.link && this.pageName != 'cat-2025') {
      window.open(course.link)
    }

  }


  details(course: any) {
    // let name:any = 'CAT 2023 Full Course + IIM ABC Practice Batch'
    // this.router.navigate(['/details/'+ name.toLowerCase().replaceAll(' ', '-')])
    window.open(course.course_link, '_self')
  }

  courseDetails: any;

  buynow(evt: any) {
    if (this.course.display_only_one) {
      // let name:any = 'CAT 2023 Full Course + IIM ABC Practice Batch'
      // this.router.navigate(['/details/'+ name.toLowerCase().replaceAll(' ', '-')])
      window.open(this.course.course_link, '_self')
    } else {
      let courseId = evt.id;
      this.coursesService.courseDetails(courseId).subscribe(res => {
        if (res.length > 0) {
          this.courseDetails = res[0];
          this.sessionStorage.setItem('cartArray', JSON.stringify(this.courseDetails))
          this.router.navigate(['cart'])
        }
      })
    }
  }

}
